import {
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { ModalDirective, BsModalRef, BsModalService } from "ngx-bootstrap";
import { EntitaAnagrafeVO } from "@app/shared/vo/gescor/entita-anagrafeVO";
import { TipoSoggettoAnagrafeEnum } from "@app/shared/enum/tipo-soggetto-anagrafe-enum";
import { RichiestaFirmaVO } from "@app/shared/vo/richiesta-firmaVO";

@Component({
  selector: "app-modale-dettaglio-soggetto-recapito",
  templateUrl: "./modale-dettaglio-soggetto-recapito.component.html",
})
export class ModaleDettaglioSoggettoRecapitoComponent implements OnInit {
  @ViewChild("templateModaleDettaglioSoggettoRecapito", { static: false })
  public modaleSoggettoRecapito: ModalDirective;
  public modalRef: BsModalRef;
  public selectedDettaglio = [];
  @Input()
  rowDettaglio: EntitaAnagrafeVO;

  @Output()
  dettaglioDiretto: EventEmitter<EntitaAnagrafeVO> = new EventEmitter();
  @Output()
  dettaglioConoscenza: EventEmitter<EntitaAnagrafeVO> = new EventEmitter();
  public messages = {
    emptyMessage: "Nessun risultato",
    totalMessage: "in totale",
  };
  private config = {
    class: "modal-dialog modal-info modal-lg",
    animated: true,
  };
  constructor(private modalService: BsModalService) { }

  public openModal(riga: EntitaAnagrafeVO) {
    this.rowDettaglio = riga;
    this.modalRef = this.modalService.show(
      this.modaleSoggettoRecapito,
      this.config
    );
  }

  ngOnInit() { }

  public isSelezionabileDettaglio(row: EntitaAnagrafeVO): boolean {
    let isSelezionabileDettaglio = true;
    if (row.tipoSoggetto === TipoSoggettoAnagrafeEnum.AMMINISTRAZIONE) {
      this.rowDettaglio.listaSoggettiRecapito
        .filter(
          (soggetto) => soggetto.tipoSoggetto === TipoSoggettoAnagrafeEnum.AOO
        )
        .forEach((_) => (isSelezionabileDettaglio = false));
    }
    return isSelezionabileDettaglio;
  }

  onSelectDettaglioConoscenza(entitaAnagrafe: EntitaAnagrafeVO) {
    this.dettaglioConoscenza.emit(entitaAnagrafe);
    this.modalRef.hide();
  }

  onSelectDettaglioDiretto(entitaAnagrafe: EntitaAnagrafeVO) {
    this.dettaglioDiretto.emit(entitaAnagrafe);
    this.modalRef.hide();
  }
}
